<template>
  <div id="locus_tool_wrap">
    <div id="locus_tool_button" @click="showHide">
      <Icon v-if="show" type="md-arrow-dropright" />
      <Icon v-else type="md-arrow-dropleft" />
    </div>
    <div id="locus_tool_container" v-show="show">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showHide() {
      this.show = !this.show;
    },
    open() {
      this.show = true;
    },
  },
};
</script>
<style>
#locus_tool_wrap {
  height: calc(100% - 50px);
  position: absolute;
  top: 0px;
  right: 0;
  z-index: 22;
}
#locus_tool_button {
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  line-height: 60px;
  text-align: center;
  font-size: 18px;
  float: left;
  position: relative;
  top: calc(50% - 50px);
  border-radius: 10px 0 0 10px;
}
#locus_tool_button:hover {
  cursor: pointer;
  opacity: 0.8;
}
#locus_tool_container {
  width: 300px;
  height: 100%;
  background: #fff;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/locusDraw.vue